export const PALETTE = ['#0891b2', '#6366f1', '#f59e0b', '#10b981', '#ef4444', '#8b5cf6', '#ec4899', '#14b8a6', '#f97316', '#3b82f6'];

export const SCOPES = [
  { id: 'org', label: 'Whole org' },
  { id: 'cohort', label: 'By cohort' },
  { id: 'role', label: 'By job role' },
];

export const METRICS = [
  { id: 'role_coverage_pct', label: 'Role coverage %' },
  { id: 'avg_coverage_pct', label: 'Avg coverage %' },
];

export const RANGES = [
  { id: 'all', label: 'All time' },
  { id: 'cal_3', label: 'Last 3 calendar years' },
  { id: 'cal_2', label: 'Last 2 calendar years' },
  { id: 'cal_1', label: 'This calendar year' },
  { id: 'last_12_months', label: 'Last 12 months' },
  { id: 'last_6_months', label: 'Last 6 months' },
  { id: 'last_3_months', label: 'Last 3 months' },
  { id: 'custom', label: 'Custom range…' },
];

// A period is a 'YYYY-MM' string; lexicographic compare is chronological.
const ymMinusMonths = (n) => {
  const d = new Date();
  d.setDate(1);
  d.setMonth(d.getMonth() - n);
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`;
};

export function periodsForRange(allPeriods, range, custom) {
  if (!allPeriods || !allPeriods.length || range === 'all') return allPeriods || [];
  const y = new Date().getFullYear();
  let start = null;
  let end = allPeriods[allPeriods.length - 1];
  switch (range) {
    case 'last_3_months': start = ymMinusMonths(2); break;
    case 'last_6_months': start = ymMinusMonths(5); break;
    case 'last_12_months': start = ymMinusMonths(11); break;
    case 'cal_1': start = `${y}-01`; break;
    case 'cal_2': start = `${y - 1}-01`; break;
    case 'cal_3': start = `${y - 2}-01`; break;
    case 'custom': start = custom?.from || null; end = custom?.to || end; break;
    default: break;
  }
  return allPeriods.filter(p => (!start || p >= start) && (!end || p <= end));
}

// Format "2025-07" → "Jul '25"
export const fmtPeriod = (p) => {
  if (!p) return '';
  const [y, m] = p.split('-');
  const d = new Date(Number(y), Number(m) - 1, 1);
  return `${d.toLocaleString('default', { month: 'short' })} '${String(y).slice(2)}`;
};

export const heatColor = (pct) => (pct == null ? 'bg-slate-50 text-slate-300' : '');

// Inline colours for the coverage bands. Using inline styles (not
// Tailwind text-* classes) keeps the cell numbers legible in BOTH
// themes — the dark-scope CSS remaps text-* classes with !important,
// which was turning the dark band text light-on-light (invisible).
export const heatStyle = (pct) => {
  if (pct == null) return {};
  if (pct >= 90) return { backgroundColor: '#10b981', color: '#04241a' };
  if (pct >= 75) return { backgroundColor: '#6ee7b7', color: '#064e3b' };
  if (pct >= 55) return { backgroundColor: '#fcd34d', color: '#713f12' };
  if (pct >= 35) return { backgroundColor: '#fb923c', color: '#431407' };
  return { backgroundColor: '#f43f5e', color: '#4c0519' };
};

export const ordinal = (n) => {
  const s = ['th', 'st', 'nd', 'rd'], v = n % 100;
  return n + (s[(v - 20) % 10] || s[v] || s[0]);
};
